import { useState, useEffect } from "react";

/**
 * Custom hook for subscription management
 */
export const useSubscription = (profile, subscriptionStatus, getSubscriptionStatus) => {
  const [subscriptionFetched, setSubscriptionFetched] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [trialExpiredModal, setTrialExpiredModal] = useState(false);
  const [isTrialClose, setIsTrialClose] = useState(false);

  useEffect(() => {
    // Fetch subscription status when profile changes
    if (
      profile &&
      !subscriptionStatus &&
      !subscriptionFetched &&
      profile.userSubscription &&
      profile.userSubscription.packageType !== "trial" &&
      profile.userSubscription.isActive
    ) {
      getSubscriptionStatus();
      setSubscriptionFetched(true);
    }
  }, [profile, subscriptionStatus, subscriptionFetched, getSubscriptionStatus]);

  useEffect(() => {
    // Update status modal based on subscription status
    if (subscriptionStatus) {
      setStatusModal(
        subscriptionStatus.overallStatus === "uncollectible" ||
          subscriptionStatus.overallStatus === "open"
      );
    }
  }, [subscriptionStatus]);

  useEffect(() => {
    // Handle trial expired modal
    if (
      profile &&
      (profile.profileSetupStep === "packageExpired" ||
        (profile.profileSetupStep === "2" &&
          profile.userSubscription &&
          !profile.userSubscription.isActive)) &&
      !isTrialClose
    ) {
      setTrialExpiredModal(true);
    }

    if (
      profile &&
      profile.profileSetupStep === "completed" &&
      profile.userSubscription &&
      profile.userSubscription.isActive
    ) {
      setIsTrialClose(false);
    }
  }, [profile, isTrialClose]);

  const closeModal = () => {
    setTrialExpiredModal(false);
    setIsTrialClose(true);
    setStatusModal(false);
  };

  const shouldShowTrialModal = () => {
    if (!profile) return false;
    return (
      (profile.profileSetupStep === "packageExpired" && trialExpiredModal) ||
      (profile.profileSetupStep === "2" &&
        profile.userSubscription &&
        !profile.userSubscription.isActive &&
        trialExpiredModal)
    );
  };

  return {
    statusModal,
    trialExpiredModal,
    closeModal,
    shouldShowTrialModal,
  };
};
